import React from 'react';
import { Row, Col, Card, CardBody, CardTitle, Container } from 'shards-react';
import { RootState, useDispatch, useSelector } from '../redux/store';
import getRole from '../utils/getRole';
import type { Role } from '../types/common';

interface RoleBasedGuardProps {
  accessibleRoles: Role[] | undefined;
  children: typeof React.Children;
}

/**
 * @param  accessibleRoles [Role[]]
 * @param  children [ReactChildren]
 * @return React.ReactElement
 */
export const RoleBasedGuard = ({ accessibleRoles, children }: RoleBasedGuardProps): React.ReactElement => {
  const { roles } = useSelector((state) => state.session);
  const myRole: Role | undefined = getRole(roles);
  const isAccessible: boolean = accessibleRoles ? accessibleRoles.includes(myRole) : false;
  // console.log(roles, myRole, accessibleRoles, isAccessible);

  if (!isAccessible) {
    return (
      <Container fluid className="main-content-container d-flex justify-content-center">
        <Row noGutters>
          <Col lg="3" md="5" className="auth-form mx-auto my-auto">
            <Card>
              <CardBody>
                <CardTitle>Permission Denied</CardTitle>
                You do not have permission to access this page.
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return <>{children}</>;
};
